import React from "react"
import CardFrame from "./CardFrame"
import { formatValue, formatChange } from "../format"
import useDashboardTexts from "../useDashboardTexts"

/** One number for the period, the one it is compared with, and the change between them. */
export default function MetricCard({ card, def, data, loading, comparing, onEdit, note = null }) {
  const t = useDashboardTexts()
  const change = data && comparing ? formatChange(data.value, data.previous) : null
  return (
    <CardFrame title={(card.title && t(card.title)) || t(def?.label) || card.metric} onEdit={onEdit} testId="dashboard-metric">
      {data?.error ? (
        <span className="text-sm text-admin_error">{t`Could not load`}</span>
      ) : (
        <>
          <div className={`text-[28px] leading-tight font-semibold text-admin_text tabular-nums ${loading ? "opacity-40" : ""}`}>{data ? formatValue(data.value, def?.unit) : "…"}</div>
          {/* the line under the figure is always there — the change, or how things stand now, or
              nothing — so every number card is the same height, with a comparison or without */}
          <div className="mt-1 min-h-[20px] leading-5">
            {note === "now" ? (
              <span className="text-xs text-admin_text_secondary">{t`As it stands now`}</span>
            ) : change ? (
              <span className={`text-sm font-semibold ${change.className}`} title={t("vs %s", formatValue(data.previous || 0, def?.unit))} data-testid="metric-change">
                {change.text}
              </span>
            ) : null}
          </div>
        </>
      )}
    </CardFrame>
  )
}
